import {buildStandardHeaders, otsBaseApi} from "../ots-api";
import {StatisticsSearchCriteria} from "../../model/statistics/statistics-search-criteria";
import {RawStatistics} from "../../model/statistics/raw-statistics";
import {BaseQueryApi} from "@reduxjs/toolkit/query";
import {OtsAsyncThunkConfigExtra, OtsState} from "../ots-store";
import {removeUndefined} from "../../util/util";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ["Statistics", "SettlementStatistics", "ActivityPeriodStatistics"]});

export const statisticsApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    searchStatistics: builder.query<RawStatistics, StatisticsSearchCriteria>({
      query: (arg) => ({
        url: `/statistics/search`,
        method: "POST",
        body: arg
      }),
      providesTags: (result, _error, arg, _meta) => {
        return [{type: "Statistics", id: "LIST"}];
      },
    }),
    searchActivityPeriodStatistics: builder.query<RawStatistics, StatisticsSearchCriteria & { activityPeriodId: string }>({
      query: (arg) => ({
        url: `/statistics/activity-period/${arg.activityPeriodId}`,
        method: "POST",
        body: arg
      }),
      providesTags: (result, _error, arg, _meta) => {
        return [
          {type: "Statistics", id: "LIST"},
          {type: "ActivityPeriodStatistics", id: arg.activityPeriodId}
        ];
      },
    }),
    searchSettlementStatistics: builder.query<RawStatistics, StatisticsSearchCriteria & { settlementId: string }>({
      query: (arg) => ({
        url: `/statistics/settlement/${arg.settlementId}`,
        method: "POST",
        body: arg
      }),
      providesTags: (result, _error, arg, _meta) => {
        return [
          {type: "Statistics", id: "LIST"},
          {type: "SettlementStatistics", id: arg.settlementId}
        ];
      },
    }),
  })
});

export const downloadStatisticsTicketsReport = (arg: StatisticsSearchCriteria, api: BaseQueryApi): Promise<Response> => {
  const headers = buildStandardHeaders(api)
  headers["Accept"] = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  headers["Content-Type"] = 'application/json'

  const request: RequestInit = {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(arg),
  }

  const baseUrl = (api.extra as OtsAsyncThunkConfigExtra).baseUrl;
  const url = `${baseUrl}/statistics/tta/download`;

  return window.fetch(url, request)
}

export const {
  useSearchStatisticsQuery,
  useSearchActivityPeriodStatisticsQuery,
  useSearchSettlementStatisticsQuery,
} = statisticsApi;
